import React from 'react';

const EventsCalendar = () => {
  return (
    <iframe
      title='eventsCalendar'
      src='https://calendar.google.com/calendar/embed?src=a603aec3817a70f7c66d8de37574d752cf4900e114784725dc3ef4ca6820528c%40group.calendar.google.com&ctz=America%2FLos_Angeles'
      width='100%'
      height='600px'
      frameBorder='0'
    ></iframe>
  );
};

export default EventsCalendar;
